import { FC, useRef, useState } from 'react';
import Swiper from 'swiper';
import { GalleryThumbnailList } from '#advertDetail/components/gallery/thumbnail';
import { GalleryItemList } from '#advertDetail/components/gallery/item';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { GalleryContext, GalleryContextType } from '#advertDetail/components/gallery/contexts';
import galleryCss from '../../assets/gallery/gallery.module.scss';
import { GalleryStub } from '#advertDetail/components/gallery';

const Gallery: FC = () => {
  const {
    advert: {
      photos,
    },
  } = useAdvertDetailContext();
  const refSwiperOriginalList = useRef<Swiper>(null);
  const refSwiperThumbnailList = useRef<Swiper>(null);
  const [activePhotoIndex, setActivePhotoIndex] = useState<number>(0);

  if (photos.length === 0) {
    return <GalleryStub />;
  }

  const galleryContextValue: GalleryContextType = {
    refSwiperOriginalList,
    refSwiperThumbnailList,
    activePhotoIndex,
    setActivePhotoIndex,
  };

  return (
    <GalleryContext value={galleryContextValue}>
      <div className={galleryCss.gallery}>
        <GalleryItemList />
        <GalleryThumbnailList />
      </div>
    </GalleryContext>
  );
};

export { Gallery };
